import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useImperativeHandle,
  forwardRef,
} from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";
import {
  Table,
  Button,
  Select,
  Row,
  Col,
  Input,
  DatePicker,
  Menu,
  Dropdown,
  Space,
} from "antd";
import { Icon } from "@iconify/react";
import axios from "axios";
import { message } from "antd";

interface ParamsType {
  id: string;
}

// interface Props {
//   ref: void;
// }

export type Props = {
  ref?: any;
};

const Hitory: React.FC<Props> = forwardRef((props, ref) => {
  const history = useHistory();
  const { id } = useParams<ParamsType>();
  const [state, setState] = useState<any>({ data: [] });
  const [loading, setLoading] = useState<boolean>(false);

  const columns = [
    {
      title: "SO",
      dataIndex: "code",
      colSpan: 1,
      key: "so",
      wkeyth: "10%",
    },
    {
      title: "Course/Treatment",
      dataIndex: "item.name",
      colSpan: 1,
      wkeyth: "20%",
      key: "courseTreatment",
      render: (data: any, record: any) => <span>{record?.item?.name}</span>,
    },
    {
      title: "Type Purchase",
      dataIndex: "typePurchase",
      colSpan: 1,
      wkeyth: "10%",
      key: "typePurchase",
      render: (data: any, record: any) => <span>-</span>,
    },
    {
      title: "Use/All",
      dataIndex: "useAll",
      colSpan: 1,
      wkeyth: "10%",
      key: "useAll",
      render: (data: any, record: any) => (
        <>
          <span>
            {record.item?.formatUsed}/{record.item?.formatTotal}
          </span>
        </>
      ),
    },
    {
      title: "First Use",
      dataIndex: "firstUse",
      colSpan: 1,
      wkeyth: "10%",
      key: "firstUse",
      render: (data: any, record: any) => (
        <span>{record?.item?.formatStartDate}</span>
      ),
    },
    {
      title: "Expired Date",
      dataIndex: "expiredDate",
      colSpan: 1,
      wkeyth: "10%",
      key: "expiredDate",
      render: (data: any, record: any) => (
        <span>{record?.item?.formatExpiredDate}</span>
      ),
    },
    {
      title: "Renew Date",
      dataIndex: "renewDate",
      colSpan: 1,
      wkeyth: "10%",
      key: "renewDate",
      render: (data: any, record: any) => (
        <span>{record?.item?.formatRenewDate}</span>
      ),
    },
    {
      title: "GE",
      dataIndex: "ge",
      colSpan: 1,
      wkeyth: "5%",
      key: "ge",
    },
    {
      title: "Course Status",
      dataIndex: "courseStatus",
      colSpan: 1,
      wkeyth: "10%",
      key: "courseStatus",
      align: "center" as const,
      render(data: any, record: any) {
        return {
          props: {
            style: {
              background:
                record.status === "course_close"
                  ? "#E76464" // Course Close
                  : record.renewDate
                  ? "#FEEFC7" // Renewal
                  : "#C7F0D8", // Pending
              color:
                record.status === "course_close"
                  ? "#FFCDCD" // Course Close
                  : record.renewDate
                  ? "#F3A086" // Renewal
                  : "#4D7E7F", // Pending
            },
          },
          children: (
            <div>
              {record.status === "course_close"
                ? "Course Close"
                : record.renewDate
                ? "Renewal"
                : "Pending"}
            </div>
          ),
        };
      },
    },
    {
      title: "Details",
      colSpan: 1,
      wkeyth: "5%",
      align: "center" as const,
      key: "key",
      render: (data: any, record: any) => (
        <div className="btn-table">
          <Button
            type="primary"
            // htmlType="submit"
            onClick={(e) => {
              console.log("record =>", record);
              history.push(
                `/opd/list/${id}/view?soId=${record._id}&itemId=${record.item?._id}`
              );
            }}
          >
            View
          </Button>
        </div>
      ),
    },
  ];
  const tableList = [
    {
      key: 1,
      so: "1 SO-10010",
      courseTreatment: "Dual Yellow 5 Times",
      typePurchase: "เปิดวงเงิน",
      useAll: "10,000/50,000",
      firstUse: "09-01-2021",
      expiredDate: "09-01-2022",
      renewDate: "",
      ge: "",
      courseStatus: "Pending",
    },
    {
      key: 2,
      so: "",
      courseTreatment: "Botox",
      typePurchase: "Unit",
      useAll: "1/2",
      firstUse: "09-01-2021",
      expiredDate: "09-01-2022",
      renewDate: "",
      ge: "",
      courseStatus: "Pending",
    },
    {
      key: 3,
      so: "2 SO-10010",
      courseTreatment: "Acne Clear",
      typePurchase: "รายครั้ง",
      touseAlltal: "9/10",
      firstUse: "28-12-2020",
      expiredDate: "28-12-2021",
      renewDate: "",
      ge: "",
      courseStatus: "Pending",
    },
    {
      key: 4,
      so: "",
      courseTreatment: "PRP",
      typePurchase: "รายครั้ง",
      useAll: "4/5",
      firstUse: "28-12-2020",
      expiredDate: "28-12-2021",
      renewDate: "",
      ge: "",
      courseStatus: "Pending",
    },
    {
      key: 5,
      so: "",
      courseTreatment: "Filler",
      typePurchase: "Unit",
      useAll: "1/1",
      firstUse: "28-12-2020",
      expiredDate: "28-12-2021",
      renewDate: "",
      ge: "3",
      courseStatus: "Course Close",
    },
    {
      key: 6,
      so: "",
      courseTreatment: "Meso Fat",
      typePurchase: "Unit",
      useAll: "1/1",
      firstUse: "28-12-2020",
      expiredDate: "28-12-2021",
      renewDate: "30-12-2021",
      ge: "",
      courseStatus: "Renewal",
    },
  ];

  // The component instance will be extended
  // with whatever you return from the callback passed
  // as the second argument
  useImperativeHandle(ref, () => ({
    getData() {
      console.log("get data...");
      getData();
    },
  }));

  const getData = async () => {
    setLoading(true);
    setState({ ...state, data: [] });
    try {
      const { data } = await axios.get(`/member-so/history?memberId=${id}`);
      if (!data) return;

      setState({ ...state, data: data.data });
    } catch (err: any) {
      console.log("err =>", err);
      message.error("Error: ", err.message);
    }

    setLoading(false);
  };

  // useEffect(() => {
  //   getData();
  // }, []);

  return (
    <div style={{ padding: "10px 0px" }} className="hitory-custom">
      <div>
        <div className="input-search">
          <Select
            bordered={false}
            placeholder="Search for SO"
            suffixIcon={
              <Icon
                icon="ant-design:caret-down-filled"
                style={{ color: "#AEAEAE" }}
              />
            }
            onChange={(e) => {
              // setDataSearch({ ...dataSearch, typeSearch: e})
              // setIsDisable({...isDisable, isSearch: true})
            }}
            // options={types}
          />
          <Input.Search
            bordered={false}
            // disabled={ isDisable?.isSearch ? false : true}
            onSearch={(e) => {
              // setDataSearch({ ...dataSearch, search: e})
            }}
          />
        </div>
      </div>

      <div style={{ marginTop: "20px" }} className="table-data">
        <Table
          columns={columns}
          // dataSource={tableList}
          dataSource={state.data}
          bordered
          scroll={{ x: 100 }}
          pagination={{ defaultPageSize: 50 }}
          locale={{ emptyText: loading ? "Loading..." : "No Data" }}
        />
      </div>
    </div>
  );
});
export default Hitory;
